import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { dateformation } from 'src/components/date-format-mdy';
import { useNavigate, useParams } from 'react-router';
// ----------------------------------------------------------------------
export default function UserTableRow({ row, selected, onEditRow, onSelectRow, onDeleteRow, serialNumber, }) {
    const { scope_of_work, supervisor, week_ending_date, project, week_starting_date } = row;
    const confirm = useBoolean();
    const popover = usePopover();
    const navigate = useNavigate();
    const { id } = useParams()

    return (
        <>
            <TableRow hover selected={ selected } >
                <TableCell padding="checkbox">
                    <Checkbox checked={ selected } onClick={ onSelectRow } />
                </TableCell>
                <TableCell>{ serialNumber }</TableCell>
                <TableCell>{ dateformation(week_starting_date) }</TableCell>
                <TableCell>{ project?.name }</TableCell>
                <TableCell>{ scope_of_work }</TableCell>
                <TableCell>{ supervisor?.first_name } { supervisor?.last_name }</TableCell>
                <TableCell>{ dateformation(week_ending_date) }</TableCell>
                <TableCell>{ project?.project_number }</TableCell>
                <TableCell align="right" sx={ { px: 1, whiteSpace: 'nowrap' } }>
                    <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell>
            </TableRow>
            <CustomPopover
                open={ popover.open }
                onClose={ popover.onClose }
                arrow="right-top"
                sx={ { width: 140 } }
            >
                <MenuItem
                    onClick={ () => navigate(`/accounts-management/payroll-project-list/payroll/${id}/view/${row.id}`, {
                        state: {
                            rowData: row,
                            projectID: id,
                            rowId: row.id
                        }
                    }) }
                >
                    <Iconify icon="solar:eye-bold" />
                    View
                </MenuItem>
                <MenuItem
                    onClick={ () => {
                        confirm.onTrue();
                        popover.onClose();
                    } }
                    sx={ { color: 'error.main' } }
                >
                    <Iconify icon="solar:trash-bin-trash-bold" />
                    Delete
                </MenuItem>

                <MenuItem
                    onClick={ () => navigate(`/accounts-management/create-weeklypayroll/${id}`, {
                        state: {
                            rowData: row,
                        }
                    }) }                >
                    <Iconify icon="solar:pen-bold" />
                    Edit
                </MenuItem>
            </CustomPopover>
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content="Are you sure you want to delete?"
                action={
                    <Button
                        variant="contained" color="error"
                        onClick={ () => {
                            confirm.onFalse();
                            onDeleteRow(row.id);
                            console.log(">>>>>>>", row.id)
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}
UserTableRow.propTypes = {
    onDeleteRow: PropTypes.func,
    onEditRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    row: PropTypes.object,
    selected: PropTypes.bool,
};